// «Ajustes de la sala» (diseño §11.7): nombre, color y quitarla. Lo técnico de la sala (rama base,
// comprobación, carpeta de relevos) no se enseña aquí: lo ajustan los agentes por la API.
import { Check } from 'lucide-react';
import { useEffect, useState } from 'react';
import { t } from '../../../i18n';
import { cn } from '../../../lib/utils';
import { oficinaApi } from '../api';
import { mensajeError } from '../errores';
import { Aviso, Boton, Campo, Etiqueta, Ventana } from '../ui';

const COLORES = ['#F0B90B', '#4FC37A', '#4F9CF5', '#A77BF3', '#FF8A3D', '#EF5B5B', '#9AABBC'];

export function DialogoSala({ projectId, alCerrar }: { projectId: string | null; alCerrar: () => void }) {
  const [nombre, setNombre] = useState('');
  const [color, setColor] = useState(COLORES[0]!);
  const [principal, setPrincipal] = useState(false);
  const [quitar, setQuitar] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    if (!projectId) return;
    setError(null);
    setQuitar(false);
    oficinaApi
      .sala(projectId)
      .then((s) => {
        setNombre(s.nombre);
        setColor(s.color);
        setPrincipal(s.principal);
      })
      .catch((e: unknown) => setError(mensajeError(e)));
  }, [projectId]);

  async function hacer(accion: () => Promise<unknown>) {
    setEnviando(true);
    setError(null);
    try {
      await accion();
      alCerrar();
    } catch (e) {
      setError(mensajeError(e));
    } finally {
      setEnviando(false);
    }
  }

  const pie = quitar ? (
    <>
      <Boton className="mr-auto" onClick={() => setQuitar(false)}>
        {t('oficinaV2.accion.cancelar')}
      </Boton>
      <Boton variante="peligro" cargando={enviando} onClick={() => projectId && void hacer(() => oficinaApi.archivarSala(projectId))}>
        {t('oficinaV2.sala.quitarSi')}
      </Boton>
    </>
  ) : (
    <>
      {principal ? null : (
        <Boton variante="fantasma" className="mr-auto text-oficina-error hover:bg-oficina-error/10" onClick={() => setQuitar(true)}>
          {t('oficinaV2.sala.quitar')}
        </Boton>
      )}
      <Boton onClick={alCerrar}>{t('oficinaV2.accion.cancelar')}</Boton>
      <Boton
        variante="primario"
        disabled={nombre.trim().length < 2 || !projectId}
        cargando={enviando}
        onClick={() => projectId && void hacer(() => oficinaApi.editarSala(projectId, { nombre: nombre.trim(), color }))}
      >
        {t('oficinaV2.sala.guardar')}
      </Boton>
    </>
  );

  return (
    <Ventana abierta={projectId !== null} alCerrar={alCerrar} ancho="sm" titulo={t('oficinaV2.sala.titulo')} pie={pie}>
      <div className="space-y-5 pb-1">
        {quitar ? (
          <Aviso tono="aviso">{t('oficinaV2.sala.quitarExplica')}</Aviso>
        ) : (
          <>
            <Etiqueta titulo={t('oficinaV2.sala.nombre')}>
              <Campo value={nombre} maxLength={40} onChange={(e) => setNombre(e.target.value)} />
            </Etiqueta>
            <div className="grid gap-2">
              <span className="text-o-texto font-medium text-oficina-texto">{t('oficinaV2.sala.color')}</span>
              <div className="flex flex-wrap gap-2" role="radiogroup" aria-label={t('oficinaV2.sala.color')}>
                {COLORES.map((c) => (
                  <button
                    key={c}
                    type="button"
                    role="radio"
                    aria-checked={c === color}
                    aria-label={c}
                    onClick={() => setColor(c)}
                    className={cn('flex h-8 w-8 items-center justify-center rounded-full outline-none ring-offset-2 ring-offset-oficina-elevada focus-visible:ring-2 focus-visible:ring-oficina-enlace', c === color && 'ring-2 ring-white/80')}
                    style={{ backgroundColor: c }}
                  >
                    {c === color ? <Check className="h-4 w-4 text-black/70" aria-hidden /> : null}
                  </button>
                ))}
              </div>
            </div>
          </>
        )}
        {error ? <Aviso tono="error">{error}</Aviso> : null}
      </div>
    </Ventana>
  );
}
